import React from 'react';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsRadio from '../ManageContractsRadioCheckbox';

// Utils.
import { generateAddress } from '../../../../utils/address';

export const OldAddress: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { filteredContracts, selectedForm, oldContract } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepOldAddress">
      {selectedForm === 1 && <h3>{t('manageContracts:manageContracts.OldAddressTitleForm1')}*</h3>}
      {selectedForm === 3 && <h3>{t('manageContracts:manageContracts.OldAddressTitleForm3')}*</h3>}

      <div className="form-items">
        {filteredContracts.map((contract, i) => {
          if (contract.meteringPoint) {
            return (
              <ManageContractsRadio
                key={contract.contractCode}
                radioID={`stepOldAddress_${i}`}
                radioName="stepOldAddress"
                onChangeFunc={(): void => dispatch(['changeOldContract', contract])}
                checkedComparison={oldContract?.contractCode === contract.contractCode}
                label={`${generateAddress(contract.meteringPoint, false)} &ndash; ${t('common:general.contractNumber')} ${contract.contractCode}`}
              />
            );
          }
          return false;
        })}
      </div>
    </section>
  );
};

export default OldAddress;
